export const getAvailableBests = (state) => {
  return state.available_bests || [];
};

export const getUserBests = (state) => {
  return state.user_bests || [];
};

export const getBestsHistory = (state) => {
  return state.history || [];
};

export const getSymbolData = (state) => {
  return state.symbols_data;
};

export const getSymbolSparkline = (state) => (symbol) => {
  const selected_symbol = state.symbols_data.find((item) => item.symbol == symbol);
  const { sparkline, first_bar_index, last_day_close, day_open } = selected_symbol;
  return {
    sparkline,
    first_bar_index,
    last_day_close,
    day_open,
  };
};
